import React from 'react'

import { Box, Grid, Step } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'
import SettingSection from './Section/Setting'
import TranslationSection from './Section/Translation'

const Option = ({ model_name, goBackPath, ...props }) =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={3}>
      <Grid size={12}><FormHeader labelKey={`options.${model_name}`} goBackPath={goBackPath} /></Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[2]} activeStep={0} orientation="vertical">
          <Step><TranslationSection {...props} /></Step>
          <Step><SettingSection /></Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(Option)
